module.exports = __webpack_public_path__ + "static/sparkle_logo_blue-9f24b148c1840d35d5cb41f0852392f9.png";